import React, { useState, useEffect } from "react";
import {
    Avatar,
    Box,
    Button,
    Grid2,
    MenuItem,
    InputLabel,
    FormControl,
    Select,
    FormHelperText,
    FormControlLabel,
    Checkbox,
    Grid,
    Modal,
    Fade,
    IconButton,
    Typography,
} from "@mui/material";
import Header from "../Header/Header";
import TextField from "@mui/material/TextField";
import consts from "../../constant";
import Axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import toast, { Toaster } from "react-hot-toast";
import { useForm, Controller } from "react-hook-form";
import "./Staking.css";
import { ToastContainer } from "react-toastify";
import CloseIcon from '@mui/icons-material/Close';

const drawerWidth = 260;

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    borderRadius: 2,
};

const CreateAdminStack = () => {
    const token = localStorage.getItem("adminToken");
    const theme = useTheme();
    const lg = useMediaQuery(theme.breakpoints.up("lg"));
    const detail = useLocation();
    const [reason, setReason] = useState();
    const [reasons, setReasons] = useState(false);
    const Navigate = useNavigate();
    const back = useNavigate();



    const [selectedType, setSelectedType] = useState("");

    // Handle manual state update (example of using setValue)
    const handleStateChange = (event) => {
        const newType = event.target.value;
        setSelectedType(newType);
        setValue("type", newType);
    };




    const [selectedDurations, setSelectedDurations] = useState(["3", "6", "9", "12"]);

    const handleCheckboxChange = (event) => {
        const value = event.target.value;
        setSelectedDurations((prevSelected) =>
            prevSelected.includes(value)
                ? prevSelected.filter((item) => item !== value) // Remove if already selected
                : [...prevSelected, value] // Add if not selected
        );
    };

    const [amount, setAmount] = useState(""); // User-entered amount
    const [twentyPercent, setTwentyPercent] = useState(""); // 20% of amount
    const [tjrmPrice, setTjrmPrice] = useState(""); // TJRM current price
    const [tokenWorth, setTokenWorth] = useState(""); // Token worth




    const [open1, setOpen1] = React.useState(false);
    const handleOpen1 = () => setOpen1(true);
    const handleClose1 = () => setOpen1(false);

    const handleAmountChange = (e) => {
        const value = e.target.value;
        setAmount(value);

        // Calculate 20% of amount
        const amountValue = parseFloat(value) || 0;
        const twentyPercentValue = amountValue * 0.2;
        setTwentyPercent(twentyPercentValue);

        // Update Token Worth if TJRM price is entered
        if (tjrmPrice) {
            setTokenWorth(twentyPercentValue / parseFloat(tjrmPrice));
        }
    };

    const handleTjrmPriceChange = (e) => {
        const value = e.target.value;
        setTjrmPrice(value);
        // Calculate token worth if 20% amount is available
        const tjrmPriceValue = parseFloat(value) || 0;
        if (twentyPercent) {
            setTokenWorth(twentyPercent / tjrmPriceValue);
        }
    };


    const {
        register,
        handleSubmit,
        setValue,
        control,
        formState: { errors },
    } = useForm();

    const [datahhhhhh, setDatahhhhhh] = useState();

    const onSubmit = async (data) => {
        console.log(data, "gvghcsv");
        handleOpen1()
        setDatahhhhhh(data);
    };


    const handleUpdate = async () => {
        try {
            console.log(datahhhhhh, "gvghcsv");

            const payload = {
                type: datahhhhhh.type,
                price: amount,
                tjrmPrice: tjrmPrice,
                twentyPercent: twentyPercent,
                tokenWorth: tokenWorth,
                durations: selectedDurations,
            };

            console.log("84545455", payload);

            const response = await Axios.post(
                `${consts.BackendUrl}/staking/createAdminStak`,
                payload,
                {
                    headers: {
                        "Access-Control-Allow-Origin": "*",
                        "Access-Control-Allow-Headers": "Content-Type, Authorization",
                        "Access-Control-Allow-Credentials": "true",
                        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
                        Authorization: localStorage.getItem("adminToken"),
                    },
                }
            );

            const { data: responseData } = response;

            if (responseData?.success) {
                toast.success(responseData?.message || "Operation successful!");
                setTimeout(() => {
                    back(`/${consts.route}/stackingHistory`);
                }, 1000);
            } else {
                toast.error(responseData?.message || "An unexpected error occurred.");
            }
        } catch (error) {
            const errorMessage =
                error?.response?.data?.message ||
                error?.message ||
                "Something went wrong!";
            toast.error(errorMessage);
            console.error(error, "Error creating pair");
        }

    }



    return (
        <div className="UserList create-asset">
            <ToastContainer />
            <Box sx={{ display: lg ? "flex" : "block" }}>
                <Header />
                <Box
                    component="main"
                    sx={{
                        flexGrow: 1,
                        p: 5,
                        width: { lg: `calc(100% - ${drawerWidth}px)` },
                        marginTop: "50px",
                    }}
                >
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Grid2 container spacing={2}>
                            <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                                <div className="d-flex align-fe">
                                    <Button
                                        className="Backbutton"
                                        variant="contained"
                                        onClick={() => {
                                            back(`/${consts.route}/stackingHistory`);
                                        }}
                                    >
                                        Back
                                    </Button>
                                </div>

                                <div className="custom_table p-10">
                                    <Grid2
                                        container
                                        spacing={0}
                                        style={{ height: "100%" }}
                                        alignItems={"center"}
                                    >
                                        <Grid2
                                            item
                                            size={{ xs: 12, sm: 12, md: 12, lg: 6, xl: 6 }}
                                            sx={{
                                                "& .MuiInputBase-input.MuiOutlinedInput-input": {
                                                    color: "white",
                                                },
                                            }}
                                        >


                                            <div className="view-inp p-10">
                                                <div className="txt-white">Type</div>
                                                <div className="mt-10">
                                                    <FormControl
                                                        fullWidth
                                                        variant="outlined"
                                                        error={!!errors.type}
                                                    >
                                                        <Controller
                                                            name="type" // The name of the field in the form data
                                                            control={control} // Provide control to the Controller component
                                                            defaultValue={selectedType} // Set default value
                                                            rules={{
                                                                required: "Type is required", // Field is required
                                                            }}
                                                            render={({ field }) => (
                                                                <Select
                                                                    labelId="type-label"
                                                                    id="type-select"
                                                                    label="Type"
                                                                    {...field} // Spread the field props here to bind to the Select component
                                                                    value={selectedType} // Set the value to the selectedType state
                                                                    onChange={(e) => {
                                                                        handleStateChange(e); // Update both form and local state
                                                                        field.onChange(e); // Update form state using react-hook-form
                                                                    }}
                                                                    sx={{
                                                                        "& .MuiSelect-icon": {
                                                                            color: "white", // Dropdown icon color
                                                                        },
                                                                        "& .MuiSelect-select": {
                                                                            color: "white", // Text color for selected value
                                                                        },
                                                                        "& .MuiOutlinedInput-notchedOutline": {
                                                                            borderColor: "white", // Border color
                                                                        },
                                                                        "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
                                                                            borderColor: "white", // Border color on hover
                                                                        },
                                                                    }}
                                                                >
                                                                    <MenuItem style={{ color: "white" }} value={"profit"}>Profit (+)</MenuItem>
                                                                    <MenuItem style={{ color: "white" }} value={"loss"}>Loss (-)</MenuItem>
                                                                </Select>
                                                            )}
                                                        />
                                                    </FormControl>
                                                    {errors.type && (
                                                        <p className="err">{errors?.type?.message}</p>
                                                    )}
                                                </div>
                                            </div>


                                            <div>
                                                {/* Amount Input */}
                                                <div className="view-inp p-10">
                                                    <div className="txt-white">Admin Total Revenue (USDT)</div>
                                                    <div className="mt-10">
                                                        <TextField
                                                            {...register("price", { required: "Price is required" })}
                                                            id="outlined-basic"
                                                            variant="outlined"
                                                            type="number"
                                                            fullWidth
                                                            value={amount}
                                                            onChange={handleAmountChange}
                                                        />
                                                        <p className="err">{errors?.price?.message}</p>
                                                    </div>
                                                </div>

                                                {/* 20% of Amount */}
                                                <div className="view-inp p-10">
                                                    <div className="txt-white">20% of Revenue (USDT)</div>
                                                    <div className="mt-10">
                                                        <TextField
                                                            id="outlined-basic"
                                                            variant="outlined"
                                                            type="number"
                                                            fullWidth
                                                            value={twentyPercent}
                                                            InputProps={{ readOnly: true }}
                                                        />
                                                    </div>
                                                </div>

                                                {/* TJRM Current Price Input */}
                                                <div className="view-inp p-10">
                                                    <div className="txt-white"> 1 TJRM  Current Price</div>
                                                    <div className="mt-10">
                                                        <TextField
                                                            {...register("tjrmPrice", { required: "Tjrm current Price" })}
                                                            id="outlined-basic"
                                                            variant="outlined"
                                                            type="number"
                                                            fullWidth
                                                            value={tjrmPrice}
                                                            onChange={handleTjrmPriceChange}
                                                        />
                                                        <p className="err">{errors?.tjrmPrice?.message}</p>
                                                    </div>
                                                </div>

                                                {/* Token Worth */}
                                                <div className="view-inp p-10">
                                                    <div className="txt-white">Distribution Amount ( TJRM Token_Worth )</div>
                                                    <div className="mt-10">
                                                        <TextField
                                                            id="outlined-basic"
                                                            variant="outlined"
                                                            type="number"
                                                            fullWidth
                                                            value={tokenWorth}
                                                            InputProps={{ readOnly: true }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                        </Grid2>

                                    </Grid2>
                                    <Grid container spacing={2} className="p-10">
                                        {/* Title */}
                                        <Grid item xs={12}>
                                            <div style={{ color: "white" }} className="text-white mb-2">
                                                Select Staking Plan to be Update
                                            </div>
                                        </Grid>

                                        {/* Staking Duration Options */}
                                        <Grid item xs={12}>
                                            <Grid container spacing={2}>
                                                {["3", "6", "9", "12"].map((duration) => (
                                                    <Grid item xs={4} key={duration}>
                                                        <div
                                                            className={`cursor-pointer flex items-center justify-center px-4 py-2 rounded-lg border 
                                transition-all text-center w-full
                                ${selectedDurations.includes(duration)
                                                                    ? "bg-blue-600 text-white border-blue-600"
                                                                    : "bg-gray-800 text-gray-300 border-gray-600 hover:bg-gray-700 hover:border-white"
                                                                }`}
                                                            onClick={() =>
                                                                handleCheckboxChange({ target: { value: duration } })
                                                            }
                                                        >
                                                            <FormControlLabel
                                                                control={
                                                                    <Checkbox
                                                                        checked={selectedDurations.includes(duration)}
                                                                        onChange={handleCheckboxChange}
                                                                        value={duration}
                                                                        sx={{
                                                                            color: "white",
                                                                            "&.Mui-checked": { color: "white" },
                                                                        }}
                                                                    />
                                                                }
                                                                label={<span className="text-white">{duration} Months</span>}
                                                                className="w-full text-center"
                                                                sx={{ color: "white" }} // Ensures text color remains white
                                                            />
                                                        </div>
                                                    </Grid>
                                                ))}
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Button
                                        type="submit"
                                        variant="contained"
                                        sx={{ margin: "20px 10px", padding: "8px 40px" }}
                                    >
                                        update
                                    </Button>

                                </div>
                            </Grid2>
                        </Grid2>
                    </form>
                </Box>



                <Modal open={open1} onClose={handleClose1} closeAfterTransition>
                    <Fade in={open1}>
                        <Box sx={modalStyle}>
                            {/* Close Button */}
                            <IconButton

                                sx={{ position: "absolute", top: 10, right: 10, backgroundColor: "lightblue", width: 30, height: 30 }}
                                onClick={handleClose1}
                            >
                                <CloseIcon />
                            </IconButton>

                            <Typography variant="h6" sx={{ textAlign: "center", mb: 3 }}>
                                Are you sure you want to update this month's token worth to {tokenWorth} TJRM?
                                Please confirm before proceeding.
                            </Typography>



                            {/* Buttons Wrapper */}
                            <Box sx={{ display: "flex", justifyContent: "center", gap: 2 }}>
                                <Button variant="contained" color="primary"
                                    onClick={handleUpdate}
                                    sx={{ flex: 1 }}>
                                    Confirm
                                </Button>
                                <Button variant="outlined" color="secondary" onClick={handleClose1} sx={{ flex: 1 }}>
                                    Cancel
                                </Button>
                            </Box>
                        </Box>
                    </Fade>
                </Modal>




            </Box>
            <Toaster />



        </div>
    );
};

export default CreateAdminStack;
